import React from 'react';
import T from 'prop-types';

import BackToDetail from 'workflow/components/NewInbox/Common/BackToDetail/BackToDetail';
import WorkflowDocumentViewer from 'workflow/containers/WorkflowDocumentViewer';
import {useHideNavBar, useHideNavBarV4} from 'workflow/utils/useHideNavBar';

import styles from './DocumentDetailView.scss';

const DocumentDetailView = ({ changeView, taskId, isNewV4 = false, workflowId}) => {
    if(isNewV4) {
        useHideNavBarV4();
    } else {
        useHideNavBar();
    }

    return (
        <div className={styles.DocumentDetailView} data-cy="DocumentDetailView">
            <BackToDetail changeView={changeView} />
            <div className={styles.DocumentDetailView__Preview}>
                <WorkflowDocumentViewer taskId={taskId} workflowId={workflowId} shouldGoBack={!isNewV4}/>
            </div>
        </div>
    );
};

DocumentDetailView.propTypes = {
    changeView: T.func,
    taskId: T.string
};

export default DocumentDetailView;
